const DEFAULT_DASHBOARD_ACCESS_PATH = "/ops-access-7f3a";

function normalizePath(value: string | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed) return DEFAULT_DASHBOARD_ACCESS_PATH;
  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  const normalized = withLeadingSlash.replace(/\/+/g, "/").replace(/\/$/, "");
  if (
    normalized === "/" ||
    normalized === "/login" ||
    normalized === "/user-login" ||
    normalized === "/register"
  ) {
    return DEFAULT_DASHBOARD_ACCESS_PATH;
  }
  return normalized;
}

export const DASHBOARD_ACCESS_PATH = normalizePath(
  import.meta.env.VITE_DASHBOARD_ACCESS_PATH,
);
export const COMPANY_LOGIN_PATH = DASHBOARD_ACCESS_PATH;
export const USER_LOGIN_PATH = `${DASHBOARD_ACCESS_PATH}/staff`;
